define('ordersDetailMollieView',[
  'app',
  'module',
  'backbone',
  'settings',
  'underscore',
  'tableView',
  'entities/orders'
], function (
    App,
    Module,
    Backbone,
    Settings,
    _,
    TableView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'orders-detail-mollie-view ' + TableView.prototype.className,
    pageSize: 50,
    pageMode: 'pagination',

    initialize: function() {
      TableView.prototype.initialize.apply(this, arguments);
     
      this.listenTo(this.model.get('order'), 'paymentLink:new', _.bind(function () {        
        this.refresh();
      }, this));
    }, 

    setFields: function() {
      var fields = [];

      fields.push({
        name: 'paymentLinkId',
        label: _.i18n('common.id'),
        bind: 'paymentLinkId',
        className: 'id'
      });

      fields.push({
        name: 'link',
        label: _.i18n('common.link'),
        bind: 'paymentLinkURL',
        className: 'link'
      });

      fields.push({
        name: 'status',
        label: _.i18n('common.status'),
        bind: 'paymentLinkStatus',
        className: 'status'
      });
      
      fields.push({
        name: 'price',
        label: _.i18n('common.price'),
        bind: 'price',
        className: 'price'
      });

      return fields;
    },

    fetch: function(first, pageSize) {
      var defer = $.Deferred();

      var params = {};
      params.pageSize = pageSize;
      params.first = first;
      params.purchaseOrderId = this.model.get('order').get('purchaseOrderId');

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('order:get-payment-links', params),
        success: _.bind(function (items) {
          var models = [];
          _.each(items, _.bind(function(item) {    
            var model = App.request('payment-link-model', item);   

            var numberLocale = 'fr-BE';
            var configNumberLocale = Settings.configValue('priceLocale');
            if (configNumberLocale)
              numberLocale = configNumberLocale;      
            
            var price = '€' + new Intl.NumberFormat(numberLocale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2}).format(item.paymentTransactionValue);
            model.set('price', price);
            models.push(model);
          }, this));
          defer.resolve(models);
        }, this),
        error: _.bind(function () {
          defer.resolve([]);
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function() {
      var defer = $.Deferred();

      if(this.fetchCountRequest)
        this.fetchCountRequest.abort();

      var params = {};      
      params.purchaseOrderId = this.model.get('order').get('purchaseOrderId');

      this.fetchCountRequest = $.ajax({
        type: 'GET',
        url: App.request('order:get-payment-links-count', params),
        success: _.bind(function (counts) {
          defer.resolve(counts);
        }, this),
        error: _.bind(function () {
          defer.reject();
        }, this)
      });

      return defer.promise();
    }
  });
});
